import { jsxs } from "react/jsx-runtime";
import { c as clsx } from "../../../../../../../chunks/clsx-DgYk2OaC.js";
const label = "_label_hdz8e_1";
const styles = {
  label,
  "label-error": "_label-error_hdz8e_12",
  "label-required": "_label-required_hdz8e_16"
};
const Label = ({
  children,
  isError,
  isRequired,
  className,
  optionalLabelText,
  ...props
}) => {
  return /* @__PURE__ */ jsxs(
    "label",
    {
      ...props,
      className: clsx(
        styles.label,
        className,
        isError && styles["label-error"],
        isRequired && styles["label-required"]
      ),
      children: [
        children,
        !isRequired && optionalLabelText && ` (${optionalLabelText})`
      ]
    }
  );
};
export {
  Label
};
